import { render, staticRenderFns } from "./PhoneTaskTypeIcon.vue?vue&type=template&id=33ba2264&scoped=true"
import script from "./PhoneTaskTypeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneTaskTypeIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneTaskTypeIcon.vue?vue&type=style&index=0&id=33ba2264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba2264",
  null
  
)

export default component.exports